let content = [
    {
      id: "general_trading_conditions",
      title: "交易条件概要",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "产品细节",
          content_before: `<p class="mb-5">
                            iFOREX为各种金融产品仪器的杠杆保证金交易提供了极具竞争力的条件，包括货币兑（外汇），商品，指数，股票和ETF（基金）的差价合约。
                            <br><br>
                            <b>点差</b><br>点差就是交易的成本- 这是卖出（买入）价与买入（卖出）价之间的差价。例如，如果美元/日元交投在101.202卖出价和101.222买入价，这两个价格之间的差额被称为点差。在这种情况下，点差为2点。
                            <br><br>
                            <b>保证金和杠杆</b><br>当“保证金”作为整体以覆盖任何您可能发生的损失时，它也允许您持有远比您的实际账户价值大得多的头寸，让您拥有以相对较少的投资获得大量利润的可能性。
                            <br><br>
                            杠杆是一把双刃剑，可以极大地放大您的利润，然而也可以轻松地放大您的损失。 当您使用的杠杠过大，失败的交易可以迅速冲销您许多获利的交易。 杠杆交易具有高度风险，可能并不适合所有投资者。
                            <br><br>
                            作为一个 iFOREX 账户的持有者，您会被放入我们的止损保护计划，这意味着您永远不会承受高于您存入金额的损失； 尽管如此，市场的一个细微的动作可能导致相应的资金损失。 我们的交易平台在执行任何委托前自动计算您的保证金要求，并在执行任何提款请求前检查可用的资金水平。
                            <br><br>
                            保证金要求与账户敞口增加有关，无论是通过开仓/平仓交易，还是在账户中有未平仓头寸时请求提取资金。保证金要求反映了任何给定资产的头寸的潜在风险，基于波动性、流动性和定价可用性。
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/交易条件/货币">货币</a></p>
                            <p class="tc-inner-link"><a href="/交易条件/大宗商品">大宗商品</a></p>
                            <p class="tc-inner-link"><a href="/交易条件/指数">指数</a></p>
                            <p class="tc-inner-link"><a href="/交易条件/股票">股票</a></p>
                            <p class="tc-inner-link"><a href="/交易条件/etfs交易所基金">ETFs交易所基金</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "保证金要求",
          content_before: `<p>
                            在欧洲和北美的冬季，每周活动始于周日22:05 GMT持续至周五21：00GMT。在这些地区的夏令时间，每周的市场活动始于周日21:05 GMT至周五20:00结束。市场活动时间可能会因公共假日或者因可能出现的特殊国际事件不寻常的突发性状况而有所不同。开始或结束时间也可以由iFOREX由于流动性和风险管理的考虑而改变。
                            <br><br>
                            虽然大部分的产品可以无障碍的交易24小时，但是某些产品却只能在特定的时间内交易，看下面：
                            </p>`,
  
          data_id: "TradingHours",
          
          products: {
            1:"货币",
            2:"商品",
            3:"指数",
            4:"股票",
            5:"贵金属（现货）",
            8:"奖金的条款和条件"
          },
          table_titles: [
            "市场",
            "交易时间（格林威治时间）",
            "第1次日间休息时间（格林威治）",
            "第2次日间休息时间（格林威治）",
            "数据有效期（格林威治时间）"
          ],
          content_after: `<p>您不确定自己要交易的产品属于哪个国家？点击这里查看<span class="tclink" target-tab="tc-view-6">根据市场划分的仪器列表</span>。</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "假日",
          content_before: `<p>
                            为了确保您了解所有市场时间和节假日，请查看下面这可能会改变交易时间的事件的列表。<br>
                            iFOREX尽最大努力保证此类信息及时更新完善。<br>
                            如需了解更多信息请联系我们。
                            </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "市场",
            "暂停交易时间（格林威治时间）",
            "重启交易时间（格林威治时间）",
          ],
          content_after: `<p class="mt-4">您不确定自己要交易的产品属于哪个国家？点击这里查看<span class="tclink" target-tab="tc-view-6">根据市场划分的仪器列表</span>。</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "订单及执行",
          content_before: `<p><b>订单类型</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>市价单</th>
                   <th></th>
                </tr>
                <tr>
                   <td>开仓</td>
                   <td>以当前可用的市价开仓的订单</td>
                </tr>
                <tr>
                   <td>平仓</td>
                   <td>以当前可用的市价平仓的订单</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>限价单</th>
                   <th></th>
                </tr>
                <tr>
                   <td>止损</td>
                   <td>止损单是以低于当前市价的价位开仓或平仓的订单。</td>
                </tr>
                <tr>
                   <td>止盈</td>
                   <td>止盈单是以高于当前市价的价位开仓或平仓的订单。</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>市价委托单</b><br>市场订单（交易请求，即打开交易，平仓关闭交易）被执行的确切时间以在公司交易平台（客户端）生效的价格执行，前提是该价格与公司服务器中显示的基本价格在预定的容差水平内，并且无论基础价格是高于还是低于交易平台（您所看到的是您所获得的或所见即所得）中指示的价格。在交易平台（客户端）中指示的价格超过上述容许水平的情况下，例如，由于在客户下订单的时间与其被接收和执行的时间之间的相关价格的移动，市场高波动性和通信延迟，订单将以公司服务器中指示的价格执行，该价格应与交易平台（市场价格）中指示的价格对称地执行。如果交易平台（客户端）中指示的价格与公司服务器中指示的价格之间存在显着差异，则订单将被拒绝。
          </p>
          <p>
             <b>限价订单</b><br>限价订单（挂单）以公司服务器提供的市场价格执行，可能与限价挂单中指示要求的价格（“滑点”）不同。 如果挂单中指示的价格在服务器提供的价格中不存在或不可用，例如由于高波动性和市场价格的差距，则可能发生滑点。 在这种情况下，将以对称和透明的方式（对称双向滑动）以第一市场给出的可用有效价格执行订单，而不考虑滑移的方向，以及客户的利益或亏损。<br><br>未在24小时内交易的产品（例如股票和指数）可能每天都有机会经历市场“跳空”，因此更容易出现滑点。 重要的是要注意，滑点不会影响负余额平衡保护，因此即使出现滑点，客户也不会损失超过投资金额（包括任何利润，如果产生获得）。
          </p>
          <p>
             <b>延迟执行</b><br>订单被延迟可能因为各种原因发生，例如客户互联网、手机或其它通讯方式连接到iFOREX服务器的技术故障，从而可能导致“悬置订单”的发生。连接通道的干扰有时会中断信号并令交易平台不可用，从而使交易者的平台与iFOREX服务器之间的数据传输被延迟。
          </p>
          <p>
             <b>悬置订单</b><br>在交易量很大或者通讯延迟的期间，悬置订单的情形可能会发生，这意味着一个限价单被下单了，但它需要点时间被确认/处理。在交易量很大或者通讯延迟的期间，可能会形成一个限价单队列。限价单下单的增加有时会导致某些限价单的确认/处理被延迟。在某些情形下，委托事实上已被执行而只是由于客户端的网络阻塞而没有被显示出来。<br><br>请记住任何单只需要下单一次。多次输入同一委托可能会令您的电脑变慢或被锁住，或由于疏忽而开启不想要的仓位。
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "负结余保护",
          content_before: `<p class="">
                iFOREX的负余额保护政策保证客户的损失仅限于其账户中投资的资金。根据该政策，客户在与iFOREX交易时，因交易亏损而导致账户出现负余额的情况将不会发生，客户的潜在损失将被限制在其账户中已存入的资金以及客户可能获得的收益之内。
              </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "奖金的条款和条件",
          content_before: `<p><b>介绍</b><br>这些奖金条款和条件与交易红利有关，包括公司提供的欢迎红利，现金返还奖金和试用帐户红利（以下简称“红利”），如下所述，并被视为公司条款和条件的组成部分。 本文所含术语的所有解释均与公司的《条款及条件》中的解释相同，可在公司的网站<a href="/">cn.iforex.com</a>上获得。</p>
          <p>
             <b>符合资格的条件</b><br>通过公司自行决定并修改后确认的，符合相关优惠资格标准的公司客户可获得奖金，根据公司要求的所有必需的注册程序，并经公司批准为合格客户（“<b>合格客户</b>”）。
             <br><br>
             本公司对其提供的任何奖金保留绝对酌情权,针对于其认为合适的任何客户和/或国家/地区.
             <br><br>
             本公司保留权利, 在其自行决定的情况下, 拒绝任何用户的登记,包括符合资格的客户,针对奖金和/或撤销提供任何奖金拥有绝对酌情权.
             <br><br>
             居住地形成居民限制司法管辖区，包括美国居民，不符合获得交易奖金的规则。
          </p>
          <p><b>可交易的红利</b>
          <br>在本公司的绝对酌情权和根据案件情况作具体裁决的基础上， 本公司同意并且决定对符合资格的客户按照存款资金量的百分比授予可交易的红利。
             <br><br>
             可交易的红利只能作为保证未平仓交易的额外保证金，并且用意于交易的目的（例如，客户将无法取出被授予的可交易的红利）。
             <br><br>
             可交易红利是被授予于每一个符合资格的客户。
             <br><br>
             欢迎奖金 - 是为首次存款者提供的可交易奖金。
          </p>
          交易红利如何分配是根据帐户中的存款获得， 以下条件适用
                      <br>
                      <ol>
                      <li class="mb-0 mt-1">在全额提款得情况下-全部交易红利将被删除</li>
                      <li>如果部分提款，则交易红利金额将调整为提款后帐户中剩余净资产的20% ，或由公司时不时全权酌情自行决定的。</li>
                      </ol>
          <u style="font-style:italic">举例</u><br><br>
          符合资格的客户同意本公司在其存款$1,000时给予其３０％的奖金．符合资格的客户将会获得额外的保证金 $300（即，该客户存款的30%）作为可交易的红利．<br><br>此类奖金将会如下反映在客户的帐户中：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>可交易的 红利</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          可交易的红利无论怎样都将不可以在任何时期被撤出.任何利用可交易的红利所赚取的利润根据本公司的取款政策和相关法律有可能会被符合资格的客户撤出.通过可交易的红利所赚取的可撤回的利润,将会显示在客户账户中的''余额''部分.
          <br><br>
          <u style="font-style:italic">举例</u><br><br>
          符合资格的客户同意本公司在其存款$1,000时给予其３０％的奖金．符合资格的客户在其账户中拥有以下净资产和余额:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>可交易的 红利</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">方案　Ａ</u><br><br>
          客户已经要求撤回其总共存款的金额($1,000).　可交易的红利将被全部除去．<br><br>这将在客户的帐户中反映如下：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>可交易的 红利</th>
                   </tr>
                   <tr>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">方案　Ｂ</u><br><br>
          客户要求提取$ 800，因此客户的净值减少到$ 200，在这种情况下，交易红利限制为净值金额的20％，即$ 40。
          <br><br>这将反映在客户的帐户上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>可交易的 红利</th>
                   </tr>
                   <tr>
                      <td>$200</td>
                      <td>$200</td>
                      <td>$240</td>
                      <td>$40</td>
                   </tr>
                </tbody>
             </table>
          </div>
          如果该帐户连续7周保持非活动状态(无任何交易），所有交易奖金将被取消.
          <br><br>
          <p><b>现金返利</b><br>
             此项现金返利的项目每周一次对符合资格的客户的帐户进行计分制，根据并受在该周所达到的成交量，并且最高金额为本公司事先所决定的一定金额（"待定奖金"）.<br><br>该待定奖金的数量可能来自某次或若干次的存款, 以存款金额的百分比的形式,或者由本公司全权决定.
          </p>
          <u style="font-style:italic">举例</u><br><br>
          某符合资格的客户已经存款 $1,000, 并享受不超过其存款金额的 40%的现金返利用来交易$20,000,000. 该客户将会获得$400 待定奖金.<br><br>此类待定奖金将会如下反映在客户的帐户中:
          <div class="table-wrapper">
             <table class="table2 mt-3 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>待定奖金</th>
                      <th>成交量</th>
                      <th>所要求的 成交量</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$400</td>
                      <td>$0</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          每个星期,根据客户的每周成交量计算的已实现的现金返利应当从总现金返利数量(待定奖金）里扣除, 并且将客户的实际每周成交量(以美元计算）与所要求的成交量按比例记入客户的帐户中, 正如在交易平台中所展示. 此处澄清,客户仅仅在完成所需成交量之后 才享受已实现的现金返利和待定奖金. 现金返利的金额(''已实现的现金返利'') 不会超过分配给客户的待定奖金．<br><br>成交量是在''进和出'' 的基础上进行计算,这也意味开仓$1 百万(或其他等值货币）并且关闭相同仓位,总计为$2 百万(或其他等值货币）作为对客户的成交量要求．
          <br><br>
          <u style="font-style:italic">举例</u><br><br>
          <u style="font-style:italic">方案　Ａ</u><br><br>
          在上述举例中的符合资格的客户, 被给予了按照每$5,000,000的成交量可得到 $100 已实现的现金返利. 1 周后, 其已经达到了$5,000,000的成交量. 因此$100 现金返利已经从待定奖金里转移到净资产中.<br><br>这将在客户的帐户中如下反映:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>待定奖金</th>
                      <th>成交量</th>
                      <th>所要求的 成交量</th>
                   </tr>
                   <tr>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$300</td>
                      <td>$5,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">方案　Ｂ</u><br><br>
          在存款后的2周后,客户已经达到成交量$5,000,000 并且赢得 $300 的利润. 因此另外的 $100 现金返利已经从待定奖金里转移到净资产中.<br><br>这将在客户的帐户中如下反映:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>待定奖金</th>
                      <th>成交量</th>
                      <th>所要求的 成交量</th>
                   </tr>
                   <tr>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          在被计算进净资产后,已实现的现金返利将可以被用于交易或者能够在任何时间内被客户撤回.任何通过投资已实现的现金返利的金额所赚取的利润也可以被符合资格的客户撤回.<br><br>现金返利的活动有时间限制，客户会在被授予待定奖金之日的头三个月之内获取已实现的返利红利。客户可以通过进一步存款从而获得资格继续享受现金返利。
          <br><br>
          <u style="font-style:italic">举例</u><br><br>
          在上述举例中的符合资格的客户,　已经决定撤回其$300的利润以及得到的$200已实现的现金返利．因此其要求撤回总共$500．剩下的$200现金返利将会作为待定奖金保留在其帐户中，所以该客户将有能力继续交易$1,000并且有两个半月的时间可以将待定奖金转换为已实现的现金返利．<br><br>这将在客户的账户中反映如下：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>余额</th>
                      <th>净资产</th>
                      <th>可使用的 保证金</th>
                      <th>待定奖金</th>
                      <th>成交量</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          所有的现金返利将按照账户的货币所给予.
          <br><br>
          <p>
             <b>试用账户</b><br>
             用户可能会获得一个试用账户，其中包括 25 美元的交易奖金（如上所述），可用于交易 - 受公司交易条件的约束 。
             <br><br>
             试用帐户有使用期限，到期时试用帐户中的所有未平交易将会被终止，从帐户试用（“试用期”）的第一次交易日期计算，3天内终止。 超过25美元（“利润”）的任何现金收益可以作用户与公司交易账户的保证金和/或交易股票衍生品使用，在用户成功完成公司注册程序并且最低存款额为100美元的情况下，或者可以根据用户的名义撤回到银行账户。 请注意，（i）提款需遵守公司的提款程序，并可能还需要支付转账费用，以及（ii）任何未提取或转入交易账户的利润，并用作交易保证金和/或 交易股票衍生品不得晚于试用账户开立第一笔交易之日起14天内撤销。
             <br><br>
             奖金仅适用于首次在公司平台注册且符合所述资格标准的客户。 奖金按照每户或每个ＩＰ地址所授予。
          </p>
          <p>
             <b>概述</b><br>
             公司自行判断有任何迹象或怀疑任何形式的非法、不公平和/或滥用交易方法或行为（包括但不限于表明旨在从交易红利中获取经济利益而不承担市场风险的交易活动模式）以及 或通过为每个客户开设、操作或管理多个账户）以及任何迹象或怀疑欺诈、操纵或违反公司有关奖金计划的协议、政策和条件的行为，将取消之前记入的所有奖金 该帐户以及任何相关帐户。 在这种情况下，公司有权自行决定并在不减损其根据与客户的协议和适用法律所享有的权利的情况下，取消和取消所有进行的交易和/或其中产生的利润或损失，并阻止所有交易。 相关账户及本公司对上述行为造成的后果不承担任何责任。
             <br><br>
             公司保留在其认为合适的情况下随时更改、修改、暂停、取消或终止任何上述奖金或上述优惠的任何方面的权利.
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "margin_information",
          id:'tc-view-24',
          title: "保证金信息",
          content_before: `
                      <p>
                      下面的窗口提供了关于账户的保证金的相关信息：
                      <div class="table-wrapper">
                         <table class="table3 mt-4 mb-4">
                            <tbody>
                            <tr>
                                  <td>净资产</td>
                                  <td style="">4995</td>
                               </tr>
                               <tr>
                                  <td>以用保证金</td>
                                  <td style="">2,500</td>
                               </tr>
                               <tr>
                                  <td>可用保证金</td>
                                  <td style="">2,495</td>
                               </tr>
                               <tr>
                                  <td>保证金利用率</td>
                                  <td style="color:green">+50.05%</td>
                               </tr>
                               <tr>
                                  <td>维持保证金</td>
                                  <td style="">500</td>
                               </tr>
                               <tr>
                                  <td>净敞口</td>
                                  <td>250000</td>
                               </tr>
                               <tr>
                                  <td>曝光范围</td>
                                  <td>+1.998%</td>
                               </tr>
                            </tbody>
                         </table>
                      </div>
                      <ul class="list-style-disc-small mb-3">
                         <li><b>以用保</b>证金显示的金额净值是在当前正在使用于未平仓合约的保证金占用。在“以用保证金”等于或大于“本金”的情况下，这表示当前帐户的杠杆率已最大化。在交易休息或中断期间，某些产品的必需保证金（详见“产品详细信息”表）会增加 -这会影响可用的保证金，特别在周末可能会大幅度降低。
                         <br>
                         以用保证金=产品中的净暴露值×该产品所需的保证金
                         </li>
                         
                         <li><b>可用保</b>证金显示在资产净值中目前没有使用并可用于将来增加净暴露的金额。如果可用保证金为零，则显示账户已最大限度地使用了杠杆。

                         <br>可用保证金=资产净值-已用保证金</li>
                         
                         <li><b>保证金利用率</b>显示正在使用的金额净值以百分比形式被用作当前未平仓交易保证金来计算。100％及以上保证金利用率，表示账户中最大的杠杆使用率。
                         <br>
                         保证金利用率％=（已用保证金/净值）×100
                         </li>
                         
                         <li><b>维持保证金</b>反映的是维持账户未平仓交易所需的已用保证金的 20%。当账户权益达到或低于规定的维持保证金时，将自动激活保证金平仓保护（定义如下）。
                         <br>
                         维持保证金=已用保证金X交易平台定义的百分比（％）
                        <br>
                        iFOREX 保留自行决定设定和/或更改维持保证金的权利，但没有义务。
                         </li>
                         
                         <li><b>持仓比率</b>显示一个账户净暴露占资产总净值的比例
                         <br>
                         持仓比率=资产净值/持仓比率
                        </li>
                      </ul>
                      <b>保证金平仓保护</b><br>如果客户的权益达到或低于维持保证金水平，iFOREX 将自动关闭消耗最大已用保证金的交易，以实现最低的维持保证金，仅影响各自交易时间内可用的工具的未平仓交易。如果当时没有未平仓交易，则第一个收到报价的工具将首先自动关闭。如果有多笔交易（多于一笔）消耗的最大已用保证金相同，则公司将自动关闭最先开仓的交易。如果无法通过自动关闭单笔交易来实现最低的维持保证金，iFOREX 将自动关闭特定工具下的所有未平仓交易。<br>
                     iFOREX 允许客户充分利用其未平仓交易的未实现利润，以支持其亏损交易。
                      <br><br>
                      <b><u><u>保证金平仓保护示例</u></u></b><br>
                      为了便于举例，维持保证金 = 已用保证金 x 20%
                    <br><br>
                      <b>示例一：多笔交易（无交易奖金）</b><br>
                      本例涉及一位拥有多笔未平仓交易的客户。账户净值跌至维持保证金水平。<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>未平仓交易：</li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>1 笔美元/日元交易：以 150.22 汇率买入 200,000 美元（已用保证金 = 0.25% x 200,000 美元 = 500 美元）</li>
                            <li>1 笔黄金交易：以 2,300.00 汇率买入 100 盎司（已用保证金 = 0.5% x 100 x 2,300.00 美元 = 1,150 美元）</li>
                            <li>1 笔 WTI 原油交易：以 70.00 汇率买入 500 桶（已用保证金 = 1% x 500 x 70 美元 = 350 美元）</li>
                         </ul>
                         <li>已用保证金总额：2,000 美元</li>
                         <li>维持保证金水平：400 美元</li>
                      </ul>
                      
                      <p><b>流程：</b></p>

                      <ol>
                        <li>当账户净值跌至或低于 400 美元时，系统将使用最高已用保证金（黄金）关闭交易。这会将已用保证金降至 850 美元，将维持保证金降至 170 美元。</li>
                        <li> 如果净值跌至或低于 170 美元，系统将关闭 USD/JPY 交易，将已用保证金降至 350 美元，将维持保证金降至 70 美元。</li>
                        <li>最后，如果净值跌至或低于 70 美元，系统将关闭最后一笔剩余交易（WTI 原油）。</li>

                      </ol>
                      <b>示例二：单笔交易（包括交易奖金）</b><br>
                      此示例涉及一个拥有一笔未平仓交易、一笔交易奖金以及等于或低于维持保证金的权益的客户。<br><br>
                      <ul class="list-style-disc-small mb-3">
                        <li><b>存款</b>：1,000 美元（含 100% 交易奖金）</li>
                        <li><b>总权益</b>：2,000 美元</li>
                        <li><b>开仓交易</b>：以美元/日元买入 800,000 美元</li>
                        <li><b>已用保证金</b>：0.25% x 800,000 美元 = 2,000 美元</li>
                        <li><b>维持保证金水平</b>：400 美元</li>
                      </ul>
                      
                      <p><b>流程：</b> 当权益跌至或低于 -600 美元，触发总权益水平为 400 美元时，系统将关闭唯一未平仓交易。</p>
                      
                      <b>示例三：多笔交易（包括交易赠金）</b><br>

                      客户持有多笔未平仓交易，其交易奖金和权益等于或低于维持保证金。<br><br>

                      <ul class="list-style-disc-small mb-3">
                        <li><b>存款</b>：1,000 美元（含 100% 交易奖金）</li>
                        <li><b>总权益</b>：2,000 美元</li>
                         <li><b>未平仓交易：</b></li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>1 笔 USD/JPY 交易：以 150.22 汇率买入 400,000 美元（已用保证金 = 0.25% x 400,000 美元 = 1,000 美元）</li>
                            <li>1 笔 WTI 原油交易：以 85.00 汇率买入 1,000 桶（已用保证金 = 1% x 1,000 x 85 美元 = 850 美元）</li>
                         </ul>
                         <li><b>已用保证金总额</b>：1,850 美元</li>
                         <li><b>维持保证金水平</b>：370 美元</li>
                      </ul>

                      <p><b>流程：</b></p>
                        <ol>
                            <li>当权益跌至或低于 -630 美元时，触发权益总额为 370 美元，美元/日元交易关闭。</li>
                            <li>随着美元/日元交易关闭，已用保证金现在为 850 美元，维持保证金水平为 170 美元（850 美元 x 20%）。</li>
                            <li>如果权益跌至 -830 美元（权益总额 = 170 美元），系统将关闭 WTI 石油交易。</li>
                        </ol>
                      
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "其他交易规则",
          content_before: `
              <p>
              <b>最大暴露</b><br>
              作为以更好的风险管理和避免单一客户过度的风险暴露为目标的一个审慎手段，iFOREX设立了每个客户最大的净暴露限额为1500（一千五百）万美元。要查看每个金融工具的最大净暴露金额请<span class="tclink" target-tab="tc-view-6" target-section="product_section">点击这里</span>。iFOREX有权在任何时间无需任何事先通知自行决定取消或变更这样的限额。
              <br><br>
              <b>对冲</b><br>
              对冲被定义为对同一金融工具或标的资产开启两个方向相反的交易（一个“买入”而另一个“卖出”），无论是否在同一时间也无论是否是相同的数量。iFOREX对于对冲交易的最低保证金以累加的或者说“净”值来考虑。进而，iFOREX认为对冲交易的其中一个交易平仓相当于开启一个金额等于余下的交易金额的新交易。
              <br><br>
              <b>交易的净额结算</b><br>
              当一个账户多于一个交易需要同时平仓时，iFOREX将所有开启的仓位视作一个批次进行平仓。每个关闭的仓位的交易编号以先入先出的原则进行分配。这意味着在关闭仓位时，最先开启的仓位将会得到最低的交易编号，而最后开启的仓位将会得到最高的交易编号。
              <br><br>
              <b>未经授权的交易行为</b><br>
              iFOREX支持公平的交易，禁止使用不正当的交易做法，如滞后交易、价格操纵、时间操纵或任何其它非法的操作和/或用来获得不公平利益的其它操作。这些被禁止的操作示例如下，但不限于以下任一：
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>剥头皮</b>是一种试图利用价格微小变化的交易策略。实施此策略的交易者将创建许多短期头寸，通常会在几秒钟或几分钟内平仓。
                 </li>
                 <li>
                    <b>自动交易</b>（例如智能交易系统EA）或算法交易是指使用电子平台通过一个算法执行预先编程的交易指令来输入交易委托，算法的变量包括时间、价格、或委托的数量、或在许多情形下通过一个“机器人”启动委托而无需人工干预。
                 </li>
                 <li>
                    <b>API交易</b>是一个应用程序接口，指所有交易通过一个软件程序与另一个程序进行交互。API像一个交易者和市场之间的中间人一样工作，中继委托并在需要时取回信息。
                 </li>
                 <li>
                    <b>“多个帐户”</b>是指一个客户设置两个或多个帐户以便从iFOREX不真诚地获得多个与帐户相关的权益的情况。
                 </li>
              </ul>
              <p>如果公司有任何迹象或怀疑，根据公司的唯一和绝对酌情权，任何形式的剥削、非法、不公平、未经授权和/或滥用交易行为，用于给客户不公平的优势，和/或欺诈 、操纵或违反公司的协议、政策、条款和条件，公司有权自行决定，在不减损其与客户的协议和适用法律规定的权利的情况下，废除和取消所有 相关账户进行的交易，包括其中产生的所有利润或损失，取消授予客户的任何奖金和/或冻结账户。</p>
              <b>错误的价格</b><br>
              在线交易技术并不完美，在非常少有的情形下，回馈可能被干扰。这可能只持续很短的时间，但一旦发生，价格就可能受影响。虽然下一个“套利委托”单很诱人，但是请记住在这种情况下价格与真实市场的价格不符，您实际填写的可能与显示的价格有很大的点差区别。在交易不是按照iFOREX实际提供的价格执行的情形下，iFOREX会认为这些订单无效并保留退单的权利。记住这些情形很少发生，通过选择不在这种时段交易，交易者就可以规避上面所描述情形造成的风险。
              <br><br>
              <b>Vault 钱包</b><br>
             此功能使客户能够提取其账户中的可用资金，而这些资金不受账户交易活动的影响，并且根据客户的判断，可以随时恢复以支持账户的交易保证金要求。公司允许客户使用 Vault 钱包，但须由公司自行决定。当 Vault 钱包可供客户使用时，将适用以下条款：(i) 公司授予的奖金不得分配给 Vault钱包；(ii) 将资金恢复到客户账户将按照最初分配给 Vault 钱包的金额进行，但不能一次性恢复所有累积金额（例如，如果客户向 Vault 钱包分配了 50 美元，然后又分配了 100 美元，则客户不能一次性恢复 150 美元，而是分别恢复最初分配的不同金额）； (iii) 如果账户变为非活动状态，公司将自动将 Vault钱包中的所有可用资金恢复到账户权益中，并根据《客户协议》第 13.3 条的条款扣除不活跃费；(iv) 公司保留根据其认为合适的方式拒绝使用 Vault钱包、更改和更新其使用条款以及取消它的权利。
              <br><br>
              <b>不活跃费</b><br>
              如果客户的账户连续十二 (12) 个月没有交易活动，则可能会被收取每季度 15 美元的不活跃费；如果账户权益低于 15 美元，则收取账户的全部权益。
              <br><br>
              <b>货币转换费</b><br>
              以与客户的交易账户货币不同的货币交易金融工具可能会使该客户承担货币转换费。
              <br><br>
              使用信用卡以交易账户货币以外的货币向交易账户注资或从交易账户中提取资金可能会受到客户信用卡公司收取的转换费的影响。
              <br><br>
              <b>某些受限制国家/地区的交易服务不可用且无法访问</b><br>
              某些受限制国家（包括但不限于美国）将无法提供或可用交易平台和/或交易服务。 了解有关某些受限制国家/地区对公司服务或网站的使用或访问限制（包括受限制国家/地区列表）的更多信息，请单击<a href="/legal/restricted-countries" target="blank">此处</a>。
              <br><br>
              关于交易的更多信息请查看我们的<a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">交易协议</a>。
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "外汇",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "隔夜利率",
          content_before: `
                  <p>
                  当您使用iFOREX交易杠杆外汇差价合约时，您的未平仓交易将在每个交易日结束时进行隔夜融资。 此隔夜融资可能需要存入或扣除，根据相关工具交易货币的相关利率来计算。货币对的加价开始于0.75％，并且可以更高，也可以在做多（买入）和做空（卖出）头寸之间有所不同。请查看下表了解最新的隔夜融资水平。
                  <br><br>
                  如果计算的“隔夜利息百分比”为正值，则表示您的帐户余额中将添加适用的金额（贷记）。 如显示负的隔夜利息百分比是指从您的帐户余额中将扣除（扣除）适用的金额。
                  <br><br>
                  你可以找到相关交易的隔夜费用比例计算，数量及其相关的运行时间的纪录，包括两种形式”交易“和“限价挂单”，在工具栏中“市场信息”选项卡里。 要计算您的账户将被扣除或添加隔夜费用与否，只需将隔夜利息百分比与交易规模相乘即可。 每个差价合约的隔夜利息流程的运行时间详见交易表格“隔夜利息（GMT）”下的“产品信息工具”。 计算的隔夜利息的价值和百分比适用于1天。 每周5天交易差价合约产品将在其相关资产交易周的最后一天以显示价值的3倍计入或扣除，因为它涵盖整个周末期间的隔夜利息。隔夜利息的金额根据差价合约的货币进行报价。 但是，如果差价合约货币的报价与账户货币不同，它将被转换为账户的货币。
                  <br><br>
                  <u><b><u>公式</u></b></u><br><br>
                  买多时的隔夜费用比例的计算（做多）：
                      <br>
  
                    <div class="formula formula_f1 mb-3">
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">其它货币3月中期银行基准利率 - 基础货币3月中期银行基准利率 + 做多买入加价</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
               
                    卖空时的隔夜费用比例（做空）：
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">其它货币3月中期银行基准利率 - 基础货币3月中期银行基准利率 - 做空卖出加价</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      为了计算隔夜利息金额，只需 简单地将百分比 X 交易金额：<br><br>隔夜费用以（金额)计算=交易金额X隔夜利息百分比
                        <br><br><br>
                        <u><b><u>示例</u></b></u><br><br>
                        <b>示例I</b><br><br>
                        这个例子涉及银行同业间价格利率差高于标价的情况。 在这种情况下，当您做多（买）时，将从您的账户余额中扣除，当您做空（卖出）账户余额将被添加：
                        <br><br>
                        <ul class="list-style-dashed mb-4">
                            <li>产品仪器 = EUR/USD (欧元兑美元)</li>
                            <li>欧元（基础货币）3月中期银行基准利率（年化）= -0.37％= -0.0037</li>
                            <li>美元（其他货币）3月中期银行基准利率（年化）= 1.08％= 0.0108</li>
                            <li>银行间价格差= 1.45％= 0.0145</li>
                            <li>做多买入加价= 0.75％ = 0.0075</li>
                            <li>做空卖出加价= 0.75% = 0.0075</li>
                            <li>交易其它货币计算金额价值= 106,550美元（100,000欧元，在目前收盘价为1.0655）</li>
                        </ul>
                        当您买入（多头头寸）隔夜利息百分比：<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    隔夜费用以（金额)计算= 106,550 X (-0.0000611) = -6.51美元, 即每天6.51每天
                    <br><br><br>
                    当您卖出（空头头寸）隔夜利息百分比：<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    隔夜费用以（金额）计算= 106,550 X 0.00001944 = 每天2.07美元
                    <br><br><br>
                    <b>示例II</b><br><br>
                    此示例涉及一种情况，即银行间利率差异高于加价，而多空标记是不同。 在这种情况下，您的帐户余额将被扣除在每晚，无论您的位置的方向：
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>产品仪器 = EUR/TRY (欧元兑土耳其里拉)</li>
                       <li>欧元（基础货币）3个月中期银行基准利率（年化）= -0.37％= -0.0037</li>
                       <li>美元（其他货币）3个月中期银行基准利率（年化）= 22.75％= 0.2275</li>
                       <li>银行间利率差异= 23.12% = 0.2312</li>
                       <li>做多买入加价= 0.75% = 0.0075</li>
                       <li>做空卖出加价= 14.00% = 0.14</li>
                       <li>交易金额价值以另一种货币表示= 620,000土耳其里拉（100,000欧元，目前收盘价为6.2000）</li>
                    </ul>
                    当您买入（多头头寸）隔夜利息百分比：<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">隔夜利息百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        隔夜利息费用以金额计算= 620,000 X (-0.000663) = -411土耳其里拉, 这意味着每日411 土耳其里拉的费用（≅80 美元）
                        <br><br><br>
                        当您卖出（空头头寸）隔夜利息百分比：<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">隔夜利息百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        隔夜利息费用以金额计算= 620,000 X 0.000253 = 157土耳其里拉 这意味着每日157 土耳其里拉的费用（≅30美元）
                        <br><br><br>
                        <b>示例III</b><br><br>
                        这个例子涉及银行同业间利率差异低于否定标价的情况。在这种情况下，您的帐户将在您做空（卖）时被扣除，反之做多（买）时被添加。
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>产品仪器 = USD/JPY (美元兑日元)</li>
                           <li>美元（基础货币）3月中期银行基准利率（年化）= 1.08% = 1.08</li>
                           <li>日元（其他货币）3月中期银行基准利率（年化）= -0.09% = -0.0009</li>
                           <li>银行间价格差 = -1.17% = -0.0117</li>
                           <li>做多买入加价= 0.75% = 0.0075</li>
                           <li>做空卖出加价= 0.75% = 0.0075</li>
                           <li>隔夜费用以（金额)计算== 10,341,000日元 (100,000美元，在目前收盘价为103.41)</li>
                        </ul>
                        当您买入（多头头寸）隔夜利息百分比：<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">隔夜利息百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        隔夜费用以（金额)计算= 10,341,000 ×0.00001167=每天120.65 日元美元(≅1.1美元)
                        <br><br><br>
                        当您卖出（空头头寸）隔夜利息百分比：<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">隔夜利息百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        隔夜费用以（金额)计算= 10,341,000 ×(-0.0000533)=-551.52日元，即每天551.52日元(≅5.3美元)
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜利息结算可能需要最多15分钟才能在交易日结束时处理，之后您的账户将被适当记入或扣除利息。</p>`,
          table_titles: [
            "产品仪器",
            "每日隔夜利息百分比（卖出）",
            "每日隔夜利息百分比（买入）",
            "隔夜费用（GMT）*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "指数和商品的差价合约",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "隔夜利率",
          content_before: `
              <p>
              当通过iFOREX交易杠杆，交易指数和商品差价合约时，您的公开交易将在每个交易日结束时进行隔夜费用计算。 这个隔夜费用可能需要扣除或添加，根据相关交易货币的相关利率，加上加价计算。 指数和大宗商品的涨幅为2.5％。打开新的交易时，点击“工具”，然后打开“产品信息”标签查看更新后最新的值。
              <br><br>
              如果计算的“隔夜利息百分比”为正值，则表示您的帐户余额中将添加适用的金额（贷记）。 如显示负的隔夜利息百分比是指从您的帐户余额中将扣除（扣除）适用的金额。
              <br><br>
              你可以找到相关交易的隔夜费用比例计算，数量及其相关的运行时间的纪录，包括两种形式”交易“和“限价挂单”，在工具栏中“市场信息”选项卡里。 要计算您的账户将被扣除或添加隔夜费用与否，只需将隔夜利息百分比与交易规模相乘即可。 每个差价合约的隔夜利息流程的运行时间详见交易表格“隔夜利息（GMT）”下的“产品信息工具”。 计算的隔夜利息的价值和百分比适用于1天。 每周5天交易差价合约产品将在其相关资产交易周的最后一天以显示价值的3倍计入或扣除，因为它涵盖整个周末期间的隔夜利息。隔夜利息的金额根据差价合约的货币进行报价。 但是，如果差价合约货币的报价与账户货币不同，它将被转换为账户的货币。
              <br><br>
              <u><b><u>公式</u></b></u><br><br>
              买多时的隔夜费用比例的计算（做多）：<br>
                  
                  <div class="formula formula_f9 mb-3">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3月期银行基准利率 + 标记</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                卖空时的隔夜费用比例（做空）：<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3月期银行基准利率 - 标记</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                为了计算隔夜利息金额，只需 简单地将百分比 X 交易金额：<br><br>隔夜费用以（金额)计算=交易金额X隔夜利息百分比
                <br><br><br>
                <u><b><u>示例</u></b></u><br><br>
                <b>示例I</b><br><br>
                这个例子涉及银行同业间价格利率高于标价的情况。 在这种情况下，当您做多（买）时，将从您的账户余额中扣除，当您做空（卖出）账户余额将被添加：
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>产品仪器=巴西盖尔道集团（Bovespa）</li>
                   <li>巴西币种（雷亚尔）3月期的银行利率（年化）= 9.567％= 0.09567</li>
                   <li>标记 = 2.5％ = 0.025</li>
                   <li>交易金额价值以货币计算= 127,380 巴西币种（2 指数合约以当前收盘价为每个合约63690 巴西币种）</li>
                </ul>
     
                当您买入（多头头寸）隔夜利息百分比：<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                隔夜费用以（金额)计算= 127,380 X (-0.0003351944) = -42.70巴西币种, 即每天42.70每天 (≅13.58美元)
                <br><br><br>
                当您卖出（空头头寸）隔夜利息百分比：<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                隔夜费用以（金额)计算= 127,380 X 0.00019630556 = 每天25巴西币种(≅7.95美元)
                <br><br><br>
                <b>示例II</b><br><br>
                这个例子涉及银行同业间价格利率低于标价的情况。 在这种情况下，您的帐户余额将被扣除在每晚，无论您的位置的方向：
                <br><br>
                <ul class="list-style-dashed">
                   <li>产品仪器=油（得克萨斯轻质原油WTI）</li>
                   <li>美元（USD）3月期银行基准利率（年化）= 1.08％= 0.0108</li>
                   <li>标记 = 2.5％ = 0.025</li>
                   <li>交易金额价值以货币计算= 53,250美元（1,000桶，以目前收盘价为每桶53.25美元）</li>
                </ul>
                <br><br>
                当您买入（多头头寸）隔夜利息百分比：
                  <br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    隔夜费用以（金额)计算= 53,250 X (-0.00009944) = -5.30美元, 即每天5.30每天
                    <br><br><br>
                    当您卖出（空头头寸）隔夜利息百分比：<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">隔夜利息百分比</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    隔夜费用以（金额)计算= 53,250 X (-0.00003944) = -2.10美元, 即每天2.10每天
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜利息结算可能需要最多15分钟才能在交易日结束时处理，之后您的账户将被适当记入或扣除利息。</p>`,
          table_titles: [
            "产品仪器",
            "每日隔夜利息百分比（卖出）",
            "每日隔夜利息百分比（买入）",
            "隔夜费用（GMT）*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "合同的翻转日期",
          content_before: `<p>
                        每个基于期货合约（即商品和指数）的CD都有延期日期。
                        <br><br>
                        在达到相关产品的到期日期时，所有打开的期货合约和差价合约（CFD）头寸将转入下一个新的合约，以便新的期货合约连续持仓。
                        <br><br>
                        在实施此类翻转时，该头寸的开仓P / L（利润/亏损）将表示过期和新的合约价格之间的价格差异，并包括加价差价。 所有相关的限价单等级应根据新的未来合约价格自动调整。
                        <br><br>
                        例如，如果WTI Oil （轻质原油）2月合约的最后价格为50.125美元，将开始的下一个合约（3月）的市价为50.805美元，则所有未完成的限价盘的价格水平将更新上涨0.68美元。
                        <br><br>
                        合同的到期日期取决于您交易的产品仪器，下面列出的是适用于iFOREX差价合约头寸的唯一翻转日期：
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["合约月份", "合同翻转(GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["商品", "指数"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "股票和ETF(指数基金)差价合约",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "隔夜利率",
          content_before: `<p>
                    当通过iFOREX交易杠杆，交易股票和ETF差价合约时，您的公开交易将在每个交易日结束时进行隔夜费用计算。这个隔夜费用可能需要扣除或添加，根据相关交易货币的相关利率，加上加价计算 。 股票和ETF的加价从5％开始，可以更高，也可以在做多（买入）和做空（卖出）位置之间有所不同。请查看下表了解最新的隔夜融资水平。
                    <br><br>
                    如果计算的“隔夜利息百分比”为正值，则表示您的帐户余额中将添加适用的金额（贷记）。 如显示负的隔夜利息百分比是指从您的帐户余额中将扣除（扣除）适用的金额。
                    <br><br>
                    你可以找到相关交易的隔夜费用比例计算，数量及其相关的运行时间的纪录，包括两种形式”交易“和“限价挂单”，在工具栏中“市场信息”选项卡里。 要计算您的账户将被扣除或添加隔夜费用与否，只需将隔夜利息百分比与交易规模相乘即可。 每个差价合约的隔夜利息流程的运行时间详见交易表格“隔夜利息（GMT）”下的“产品信息工具”。 计算的隔夜利息的价值和百分比适用于1天。 每周5天交易差价合约产品将在其相关资产交易周的最后一天以显示价值的3倍计入或扣除，因为它涵盖整个周末期间的隔夜利息。隔夜利息的金额根据差价合约的货币进行报价。 但是，如果差价合约货币的报价与账户货币不同，它将被转换为账户的货币。
                    <br><br>
                    <u><b><u>公式</u></b></u><br><br>
                    买多时的隔夜费用比例的计算（做多）：
                  <br>
                  
                  <div class="formula formula_f15 mb-3">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3月期银行基准利率 + 标记</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                卖空时的隔夜费用比例（做空）：

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3月期银行基准利率 - 标记</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                为了计算隔夜利息金额，只需 简单地将百分比 X 交易金额：<br><br>隔夜费用以（金额)计算=交易金额X隔夜利息百分比
                <br><br><br>
                <u><b><u>示例</u></b></u><br><br>
                <b>示例I</b><br><br>
                这个例子涉及银行同业间价格利率高于标价的情况。 在这种情况下，当您做多（买）时，将从您的账户余额中扣除，当您做空（卖出）账户余额将被添加：
                <br><br>
                <ul class="list-style-dashed">
                   <li>产品仪器=俄罗斯天然气工业公司（GAZP）</li>
                   <li>俄罗斯卢布（RUB）3月期银行基础利率（年化）= 9.5％= 0.095</li>
                   <li>标记 = 5％ = 0.05</li>
                   <li>交易金额价值以货币计算= 2,459,000卢布（20,000股以目前收盘价为每股122.95卢比）</li>
                </ul>
                <br><br>
                当您买入（多头头寸）隔夜利息百分比：<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                隔夜费用以（金额)计算= 2,459,000 X (-0.0004) = -983.60卢布, 即每天983.60每天(≅14.60美元)
                <br><br><br>
                当您卖出（空头头寸）隔夜利息百分比：<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>
                隔夜费用以（金额)计算= 2,459,000 X 0.000125 = 每天307.38卢布(≅5.48美元)
                <br><br><br>
                <b>示例II</b><br><br>
                这个例子涉及银行同业间价格利率低于标价的情况。 在这种情况下，您的帐户余额将被扣除在每晚，无论您的位置的方向：<br>
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>产品仪器=苹果（AAPL）</li>
                   <li>美元（USD）3月期银行基准利率（年化）= 1.08％= 0.0108</li>
                   <li>标记 = 5％ = 0.05</li>
                   <li>交易金额价值以货币计算= 70,600美元（500股，以目前收盘价为每股141.20美元）</li>
                </ul>
           
                当您买入（多头头寸）隔夜利息百分比：<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                隔夜费用以（金额)计算= 70,600 X (-0.000169) = -11.93美元, 即每天11.93每天
                <br><br><br>
                当您卖出（空头头寸）隔夜利息百分比：<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">隔夜利息百分比</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>
                隔夜费用以（金额)计算= 70,600 X (-0.000109) = -7.70美元, 即每天7.70每天
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜利息结算可能需要最多15分钟才能在交易日结束时处理，之后您的账户将被适当记入或扣除利息。</p>`,
          table_titles: [
            "产品仪器",
            "每日隔夜利息百分比（卖出）",
            "每日隔夜利息百分比（买入）",
            "隔夜费用（GMT）*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "股息分红",
          content_before: `<p>
                        如果与股票差价合约相关的现金股利分配，将根据客户在除息日之前的工作日结束时持有的相关股份的持仓计算，对客户的余额进行股息调整。股息调整应根据股息的大小，客户头寸的大小以及是否为买入或卖出的交易来计算，因此在长期头寸中，调整将记入客户的余额，在短期头寸中调整应从客户的余额中扣除。股息将在相关股份的交易时间之外，在股票下一个交易日开始前，从客户的余额贷记或借记，并且取决于客户在股息调整时持有其各自的头寸。在此期间，为了在下一个交易日开始前保持客户资产的公允价值，本公司将根据客户余额中扣除或记入的股息金额调整客户头寸。
                        <br><br>
                        <u>举例:</u><br>
                        可口可乐发行每股0.35美元的股息。<br>
                        除息日为11月29日， 并且iFOREX的结算日期是格林尼治时间11月28日22:05。<br>
                        结算前收盘价为41.65。<br>
                        一个交易者持有5000股的多头的头寸，如果其交易持续至结算日，将被记入0.35 x 5000 = 1750美元。
                        <br>
                        类似金额将从持有空头头寸的客户的余额中扣除。
                        <br>
                        股票价格将在股市休市后从41.65被调整为41.30，等于最后股价减去股息金额。
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"目前没有关于未来股息的信息",
          table_titles: [
            "股票 / 指数基金",
            "市场",
            "股息分红金额",
            "日期和时间格林威治时间（GMT）",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "股票拆分和其他企业动态",
          content_before: `<p>
                        公司行为是影响上市公司股票价值的某些事件。 除非本文就特定公司行为另有规定，否则在特定股票发生公司行为时，iFOREX 应清算相关差价合约的任何未平仓头寸，包括在需要时取消任何限价单 此类差价合约的 (s)。
                        <br><br>
                        iFOREX 中的公司行为包括配股、退市和任何其他对股票价格产生重大影响或可能产生重大影响的事件（包括重大公司公告、收购、合并、破产等）。
                        <br><br>
                        <strong>
                        股票拆分和反向股票拆分的具体规则
                        </strong>
                        <br>
                        交易所的股票拆分和反向股票拆分不会改变持有股票的人的股票总价值，而是会改变股票的数量和价格。 这些拆分通常在股价过高或过低时实施。 如果未平仓交易/限额遇到股票拆分，其金额、比率和相关限额水平将相应调整（包括账户余额，由于所需的盈亏进行调整，如果有的话）。
                        <br><br>
                        例如，在 1:10 拆分中，1 支股票在事件发生后变成 10 支股票，价格除以 10，股票的整体价值不变。 例如，价格为 1,000 美元的 1 支股票在事件发生后将变成 10 支价格为 100 美元的股票：1x 1,000 美元 = 10 x 100 美元 = 1,000 美元的价值。
                        <br><br>
                        请看下面即将推出的企业动态的清单：
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"这里目前没有有关企业未来动向趋势的信息",
          table_titles: ["股票 / 指数基金", "市场", "种类", "日期和时间格林威治时间（GMT）"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "收益报告",
          content_before: `<p>
                            收益报告是上市公司定期提交的一份报告，用于报告其业绩。通过分析季度收益报告，投资者可以分析公司的财务状况。一家公司（尤其是市值较高的知名公司）的收益公告可能会影响其股价，从而导致其股价在发布此类季度收益报告的日子里大幅波动。
                            <br><br>
                           因此，在整个发布期间，相关股票的最大风险敞口将降至 10,000 美元。
                 
                             </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  